import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store, Actions, ofActionDispatched, Select } from '@ngxs/store';
import { ResetPasswordSuccess, ResetPassword, ResetPasswordFailure } from '../../state/auth/auth.actions';
import { AuthState } from '../../state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-reset-page',
  templateUrl: './reset-page.component.html',
  styleUrls: ['./reset-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPageComponent implements OnInit, OnDestroy {
  @Select(AuthState.getLoading)
  loading$: Observable<boolean>;

  form: FormGroup;
  view: 'reset' | 'success' = 'reset';
  email: string;

  private ngUnsubscribe = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private store: Store,
    private actions: Actions,
    private snackbar: MatSnackBar
  ) { 
    const profileCheck = this.store.selectSnapshot(AuthState.getProfileCheck);
    const email = profileCheck ? profileCheck.email : '';

    this.form = this.formBuilder.group({
      'email': [email, Validators.email]
    });
  }

  ngOnInit() {
    this.actions
      .pipe(
        ofActionDispatched(ResetPasswordSuccess),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((action: ResetPasswordSuccess) => {
        this.handleResetSuccess(action.email);
      });

    this.actions
      .pipe(
        ofActionDispatched(ResetPasswordFailure),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.handleResetFailure();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleSubmit() {
    if (this.form.valid) {
      const email = this.form.get('email').value;
  
      this.store.dispatch(new ResetPassword(email));
    }
  }

  handleResetSuccess(email) {
    this.email = email;
    this.view = 'success';
  }

  handleResetFailure() {
    this.snackbar.open('There was an error resetting your password.');
  }
}
